import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainPage from './MainPage';
import Service from './Page/Service';
import Stepss from './Page/Stepss';
import Consulting from './Page/Consulting';
import Models from './Page/Models';
import Price from './Page/Price';
import Details from './Page/Details';
import PageNotFound from  './Page/PageNotFound';
import About from './Page/About';
import CV from './Page/CV';



const App = () => {
  return (
    <Router>
        <Routes>
          <Route exact path='/' element={<MainPage/>}/>
          <Route exact path='/Service' element={<Service/>}/>
          <Route exact path='/Form' element={<Stepss/>}/>
          <Route exact path='/Consulting' element={<Consulting/>}/>
          <Route exact path='/Models' element={<Models/>}/>
          <Route exact path='/Details' element={<Details/>}/>
          <Route exact path='/Price' element={<Price/>}/>
          <Route exact path='/About' element={<About/>}/>
          <Route exact path='/CV' element={<CV/>}/>
          <Route path="*" element={<PageNotFound />}/>
        </Routes>
    </Router>
    );
  }


export default App;
